"use client";

import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

import { cn } from "@/lib/utils";

const GAP_MIN_MS = 5000;
const GAP_SPREAD_MS = 8000;

export function RankGleam({ gleam, className }: { gleam: string; className?: string }) {
  const [sweeping, setSweeping] = useState(false);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (reduceMotion) return;
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      timer = setTimeout(
        () => {
          if (!document.hidden) setSweeping(true);
          schedule();
        },
        GAP_MIN_MS + Math.random() * GAP_SPREAD_MS,
      );
    };
    schedule();
    return () => clearTimeout(timer);
  }, [reduceMotion]);

  if (reduceMotion || !sweeping) return null;

  return (
    <div
      aria-hidden
      onAnimationEnd={() => setSweeping(false)}
      className={cn(
        "animate-rank-sweep pointer-events-none absolute bottom-[-25%] left-0 top-[-25%] w-[55%] mix-blend-soft-light",
        className,
      )}
      style={{
        backgroundImage: `linear-gradient(90deg, transparent 0%, rgb(${gleam} / 0.3) 42%, rgb(${gleam} / 0.85) 50%, rgb(${gleam} / 0.3) 58%, transparent 100%)`,
      }}
    />
  );
}
